
/* START_TEMPLATE */
define('plugins/hbs/hbs.custom!coach/cumulative/view/templates/game-chooser-dialog',['hbs','handlebars','plugins/hbs/helpers/timeformat'], function( hbs, Handlebars ){ 
var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers);
  var buffer = "", stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function";

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <li class=\"game\" ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isDisabled), {hash:{},inverse:self.noop,fn:self.program(2, program2, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " data-game-id=\""
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.teamGameDto)),stack1 == null || stack1 === false ? stack1 : stack1.game)),stack1 == null || stack1 === false ? stack1 : stack1.gameId)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n            <span class=\"check\">\n                ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isDisabled), {hash:{},inverse:self.noop,fn:self.program(4, program4, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                    <span class=\"selected\"><img src=\"/Content/kickoff/icons/save-fill.svg\" /></span>\n                    <span class=\"unselected\"><img src=\"/Content/kickoff/icons/circleempty.svg\" /></span>\n                ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isDisabled), {hash:{},inverse:self.noop,fn:self.program(9, program9, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            </span>\n            <span class=\"game-name\">"
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.teamGameDto)),stack1 == null || stack1 === false ? stack1 : stack1.game)),stack1 == null || stack1 === false ? stack1 : stack1.opponentName)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</span>\n            <span class=\"game-date\">"
    + escapeExpression((helper = helpers.timeformat || (depth0 && depth0.timeformat),options={hash:{}},helper ? helper.call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.teamGameDto)),stack1 == null || stack1 === false ? stack1 : stack1.game)),stack1 == null || stack1 === false ? stack1 : stack1.date), "L", options) : helperMissing.call(depth0, "timeformat", ((stack1 = ((stack1 = (depth0 && depth0.teamGameDto)),stack1 == null || stack1 === false ? stack1 : stack1.game)),stack1 == null || stack1 === false ? stack1 : stack1.date), "L", options)))
    + "</span>\n        </li>\n        ";
  return buffer;
  }
function program2(depth0,data) {
  
  
  return "disabled";
  }

function program4(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isFutureGame), {hash:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                ";
  return buffer;
  }
function program5(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                <abbr title=\"You haven't played this game yet. We'll include any stats you have for this game automatically after "
    + escapeExpression((helper = helpers.timeformat || (depth0 && depth0.timeformat),options={hash:{}},helper ? helper.call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.teamGameDto)),stack1 == null || stack1 === false ? stack1 : stack1.game)),stack1 == null || stack1 === false ? stack1 : stack1.date), "L", options) : helperMissing.call(depth0, "timeformat", ((stack1 = ((stack1 = (depth0 && depth0.teamGameDto)),stack1 == null || stack1 === false ? stack1 : stack1.game)),stack1 == null || stack1 === false ? stack1 : stack1.date), "L", options)))
    + "\">\n                    ";
  return buffer;
  }

function program7(depth0,data) {
  
  
  return "\n                <abbr title=\"We couldn't find any stats for this game\">\n                    ";
  }

function program9(depth0,data) {
  
  
  return "\n                </abbr>\n                ";
  }

  buffer += "<header class=\"smooth-modal-header\">\n    <h2>Show Stats from these Games</h2>\n\n    <div class=\"smooth-modal-close\">\n        <svg version=\"1.1\" baseProfile=\"basic\" id=\"Layer_1\"\n             xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 612 792\"\n             xml:space=\"preserve\">\n        <path stroke=\"#FFFFFF\" stroke-width=\"8.634500e-02\" d=\"M414.7,396l195.7,195.7L501.7,700.5L306,504.8L110.3,700.5L1.5,591.7\n        L197.3,396L1.5,200.3L110.3,91.6L306,309L501.7,91.6l108.7,108.7L414.7,396z\" />\n        </svg>\n    </div>\n</header>\n\n<div class=\"smooth-modal-content has-footer\">\n    <ul id=\"game-chooser\">\n        ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.scheduleGames), {hash:{},inverse:self.noop,fn:self.program(1, program1, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </ul>\n</div>\n<div class=\"actions smooth-modal-footer\">\n    <a href=\"#\" class=\"btn-cancel\">Cancel</a>\n    <button id=\"update-season-filter\" class=\"btn-primary\">Filter Games</button>\n</div>";
  return buffer;
  });
Handlebars.registerPartial('coach_cumulative_view_templates_game-chooser-dialog', t);
return t;
});
/* END_TEMPLATE */
;